export const appCdnURL = ""

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"https://app.medmastery.com/favicon/apple-touch-icon.png"},{"rel":"icon","type":"image/svg+xml","href":"https://app.medmastery.com/favicon/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://app.medmastery.com/favicon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://app.medmastery.com/favicon/favicon-16x16.png"},{"rel":"mask-icon","href":"https://app.medmastery.com/favicon/safari-pinned-tab.svg","color":"#5bbad5"},{"rel":"manifest","href":"https://app.medmastery.com/favicon/site.webmanifest"}],"style":[],"script":[{"innerHTML":"window.dataLayer = window.dataLayer || [];\n          window.dataLayer.push({\n            'gtm.start': new Date().getTime(),\n            event: 'gtm.js',\n          });"},{"async":true,"src":"https://www.googletagmanager.com/gtm.js?id=GTM-NL5PR89"},{"src":"https://status.medmastery.com/embed/script.js","tagPosition":"bodyClose"},{"src":"https://bt.fraud0.com/api/v2/fz.js?cid=6e4a42bf-13da-424e-9a1e-d529434d1b2b","async":true,"tagPosition":"bodyOpen"}],"noscript":[],"title":"Medmastery"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000